/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelDatetime = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--datetime holds--data isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div role="select" class="panel--content">'+
                    '            <input aria-label="{{ title }}" type="text" placeholder="{{ placeholder }}" class="calendar" />'+
                    '        </div>'+
                    '        {% button %}'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var button = '<div class="panel--done">'+
                    '   <button type="submit" class="done--button" aria-label="{% go_button_text %}">'+
                    '        <div class="button--arrow"></div>'+
                    '   </button>'+
                    '</div>';

        return {'base': base, 'button': button};
    },
    formatDate: function(item) {
      var isDateTime = this.data && this.data.meta && this.data.meta.isDateTime;
      var format = isDateTime ? "L LT" : "L";
      if (this.isTime) {
        format = "HH:mm";
      }
      return moment(item).format(format);
    },
    parseDate: function(item) {
      var isDateTime = this.data && this.data.meta && this.data.meta.isDateTime
      var format = isDateTime ? 'L LT' : 'L'
      return moment(item, format).toDate();
    },
    validate: function(selectedDates, mode) {
        var length = mode === "single" ? 1 : 2
        return selectedDates && selectedDates.length === length ||
          (!selectedDates || selectedDates.length === 0) && this.data.is_required === false
    },
    attach: function() {
        // week start from Monday
        flatpickr.l10ns.default.firstDayOfWeek = 1;
        flatpickr.l10ns.default.rangeSeparator = ' - ';
        var meta = Object.clone(this.data.meta);

        meta.mode = this.data.type && this.data.type.name ? this.data.type.name : meta.mode;
        if (meta.mode === "datetime_range") {
            meta.mode = "range";
        } else if (meta.mode == "datetime" || meta.mode == "time") {
            meta.mode = "single";
        }
        var mode = meta && meta.mode ? meta.mode : "single";
        var lang = this.data.language.toLowerCase();
        var Done = this.element.getElements('.done--button');
        var isTime = this.isTime = this.data.type && this.data.type.name === "time";
        var config = {
          static: true,
          inline: true,
          allowInput: !isTime,
          parseDate: !isTime ? this.parseDate.bind(this) : undefined,
          formatDate: !isTime ? this.formatDate.bind(this) : undefined,
          dateFormat: isTime ? 'H:i' : undefined,
          enableTime: meta.isDateTime || isTime,
          minTime: isTime ? meta.minTime : (meta.minTime ? "01-01-2020 " + meta.minTime : undefined),
          maxTime: isTime ? meta.maxTime : (meta.maxTime ? "01-01-2020 " + meta.maxTime : undefined),
          mode: mode == "birthdate" ? "single" : mode,
          plugins: [],
          noCalendar: isTime,
          onChange: FunctionUtilities.debounce(function (selectedDates, dateStr, instance) {
            var valid = this.validate(selectedDates, config.mode);
            Done.set("disabled", !valid);
            if (!Done.length && valid && !isTime && !meta.isDateTime && config.mode === 'single') {
              this.after()
              instance.input.blur()
            }
          }.bind(this), 300),
        };

        moment.locale(lang)
        if (flatpickr.l10ns[lang]) {
            config.locale = flatpickr.l10ns[lang]
        } else {
            lang = lang.split("-")[0]
            if (flatpickr.l10ns[lang]) {
                config.locale = flatpickr.l10ns[lang]
            }
        }
        if (config.locale) {
            config.locale.firstDayOfWeek = 1;
            config.locale.rangeSeparator = ' - ';
        }
        var max_value = typeof meta.max_value !== 'undefined' ? meta.max_value : null;
        var min_value = typeof meta.min_value !== 'undefined' ? meta.min_value : null;

        if(mode === "birthdate") {
            config["minDate"] = typeof meta.max_value !== 'undefined' ? moment().add(-max_value, 'y').toDate() : null;
            config["maxDate"] = typeof meta.min_value !== 'undefined' ? moment().add(-min_value, 'y').toDate() : moment().toDate();
        } else {
            config["maxDate"] = max_value;
            config["minDate"] = min_value;
        }

        if(meta.limit) {
            config["enable"] = [meta.limit];
        }
        if (this.data.answerValue) {
            config["defaultDate"] = this.data.answerValue;
        } else if (meta.default) {
            config["defaultDate"] = meta.default;
        }

        // Done.set("disabled", !this.validate(config.defaultDate, config.mode))
        var container = this.element.getElementsByClassName("calendar")[0];

        if(Done.length){
            Done.each(function(oDone,i){
                oDone.addEvents({
                    click: FunctionUtilities.debounce(function(){
                        this.after();
                        this.flatpickr.input.blur();
                    }.bind(this), 300)
                });
            }.bind(this));
        }

        container.getSiblings().each(function(elem) {
            elem.destroy()
        });
        var getConfigOption = function(option) {
            var updatedOption = option;
            if (typeof option === 'string' && option.startsWith('function')) {
                updatedOption = eval('(' + option + ')')
            }
            return updatedOption;
        }
        if (meta.config) {
            if (meta.config.disable && meta.config.disable.length > 0) {
                config.disable = meta.config.disable.map(function(option){
                    return getConfigOption(option);
                });
            }

            if (meta.config.enable && meta.config.enable.length > 0) {
                config.enable = meta.config.enable.map(function(option){
                    return getConfigOption(option);
                });
            }

            if (meta.config.minDate) {
                config.minDate = getConfigOption(meta.config.minDate);
            }

            if (meta.config.maxDate) {
                config.maxDate = getConfigOption(meta.config.maxDate);
            }

            if (meta.config.minTime) {
                config.minTime = getConfigOption(meta.config.minTime);
            }

            if (meta.config.maxTime) {
                config.maxTime = getConfigOption(meta.config.maxTime);
            }

            if (meta.config.getTimeLimits) {
                config.plugins.push(new minMaxTimePlugin(
                  {
                      getTimeLimits: getConfigOption(meta.config.getTimeLimits),
                      minTime: config.minTime,
                      maxTime: config.maxTime
                  }
                ))
            }

            if (meta.config.defaultHour) {
                config.defaultHour = getConfigOption(meta.config.defaultHour);
            }

            if (meta.config.defaultMinute) {
                config.defaultMinute = getConfigOption(meta.config.defaultMinute);
            }
            if (meta.config.minuteIncrement) {
                config.minuteIncrement = getConfigOption(meta.config.minuteIncrement);
            }
            if (meta.config.hourIncrement) {
                config.hourIncrement = getConfigOption(meta.config.hourIncrement);
            }
            if (meta.config.defaultDate) {
              config.defaultDate = getConfigOption(meta.config.defaultDate);
            }
        }
        this.flatpickr = flatpickr(container, config);
        this.flatpickr.open();
        this.flatpickr.setDate(config.defaultDate, true);
        if (isTime) {
            this.flatpickr.input.setAttribute("type", "hidden");
        }
        this.flatpickr.calendarContainer.set('aria-hidden', true);
        if (mode === "birthdate") {
            var yearInput = this.element.getElements('.cur-year').getLast()
            if (yearInput) {
                yearInput.placeholder = yearInput.value;
                yearInput.value = '';
                yearInput.focus()
            }
        }
    },
    populate: function(result){
        if (this.data.meta && this.data.meta.getSettingsScript) {
            this.getSettingsScriptCallback(this.data.meta.getSettingsScript, function(config) {
                if (config) {
                    this.data.meta.config = config;
                }
                QuriobotElement.prototype.populate.bind(this)(result)
            }.bind(this))
        } else {
            return QuriobotElement.prototype.populate.bind(this)(result)
        }
    },
    after: function(answer){
        var value = this.flatpickr.selectedDates.map(function(item) {
            if (this.isTime) {
                return this.formatDate(item);
            }
            return item.toISOString();
        }.bind(this));
        var text = this.flatpickr.selectedDates.map(this.formatDate.bind(this)).join(" - ");

        // Add `aria-hidden="true"` after answering to the question
        this.setAriaHidden('.calendar', true);

        // Remove `aria-hidden="true"` from redo-button
        this.setAriaHidden('.icon--redoWrapper', false);

        this.element.addClass('isAnswered');
        this.answerCallback(this.data, {
            answer:{
                'value': value.length === 1 ? value[0] : value,
                'content': text,
                'render': false
            }
        });
        this.foldOutClose();
    }
});
